module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Datenschutz",
	"footer.privacy.url": "https://www.grohe.de/de_de/unternehmen/datenschutz.html",
	"footer.disclaimer.text": "Impressum",
	"footer.disclaimer.url": "https://www.grohe.de/de_de/unternehmen/impressum.html",
	"footer.copyright": "&copy; 2017 Grohe Deutschland Vertriebs GmbH",
	"homepage.headline": "Konfigurator für GROHE Wassersysteme",
	"homepage.introtext": "GROHE Blue oder GROHE Red? Bitte beantworten Sie ein paar Fragen, um herauszufinden, welches Produkt genau Ihren persönlichen Bedürfnissen entspricht.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Seite nicht gefunden",
	"404.link.goBack": "Zurück zur Startseite",
	"configurator.button.seeResults": "Schauen Sie sich die Ergebnisse an.",
	"question1.question": "Do you have a cold and warm water supply in your kitchen?",
	"question1.option1.text": "Yes",
	"question1.option2.text": "No",
	"question2.question": "What type of water are you looking for?",
	"question2.option1.text": "Boiling hot water",
	"question2.option2.text": "Chilled & Sparkling",
	"question2.option3.text": "Chilled and sparkling as well as boiling hot water",
	"question3.question": "Do you want to keep your existing kitchen tap?",
	"question3.option1.text": "I want to keep it",
	"question3.option2.text": "New",
	"question4.question": "What should be your main tap?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "What´s your prefered spout design?",
	"question5.option1.text": "L-shaped spout",
	"question5.option2.text": "C-shaped spout",
	"question5.option3.text": "U-shaped spout",
	"question6.question": "Should the faucet have a pull-out?",
	"question6.option1.text": "Yes",
	"question6.option2.text": "No",
	"question7.question": "What´s your preferred finish?",
	"question7.option1.text": "Chrom",
	"question7.option2.text": "Supersteel",
	"question7.option3.text": "Brushed Hard Graphite",
	"question7.option4.text": "Brushed Warm Sunset",
	"question7.option5.text": "Velvet Black",
	"question8.question": "Which boiler size do you need?",
	"question8.option1.text": "M-Size",
	"question8.option2.text": "L-Size",
	"results.title": "{productGroupsCount, plural, \none {Ihr Ergebnis} \nother {Ihre Ergebnisse}\n}",
	"results.proposal.title": "Ergebnis {number}",
	"results.proposal.title.single": "Ergebnis",
	"results.bundle.title": "Für die vollständige Installation benötigen Sie außerdem:",
	"results.newConfiguration.title": "Möchten Sie ein weiteres Wassersystem konfigurieren?",
	"results.newConfiguration.buttonText": "Neue Konfiguration beginnen",
	"results.product.number": "Produktnummer:  #{number}",
	"results.product.button.productInformation": "Produktdetails",
	"results.product.button.dealerLocator": "Ausstellung finden",
	"results.product.button.buyNow": "Online kaufen",
	"results.product.button.downloadPDF": "PDF herunterladen",
	"results.product.information": "Produktdetails",
	"results.product.dealer": "Ausstellung finden",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"app.components.HomePage.header": "GROHE SmartControl Konfigurator",
	"app.components.NotFoundPage.header": "Seite nicht gefunden"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.de_de.json
// module id = 775
// module chunks = 0